<div class="icon-group" *ngIf="options && options.length" [class.use-opacity]="useOpacity" (mouseout)="moItem = null">
	<div
	*ngFor="let option of options; let i = index;"
	(click)="onOptionClicked(option)"
	class="icon-group-item selected-arrow-down"
	[class.ie-icon-button]="!useImages"
	[class.in-radio-list]="!useImages"
	[class.selected]="!actionOnly && selectedOption?.value === option.value"
	[class.disabled]="option?.disabled"
	[style.margin-right]="(extraMargins && extraMargins.indexOf(i + 1) !== -1 ) ? '16px' : null"
	(mouseover)="moItem = option"
	title="{{option?.label}}">
		<span *ngIf="option?.icon"><i [ngClass]="'fa fa-' + option?.icon"></i></span>
		<img class="svg-icon" *ngIf="option?.svgIcon" [src]="option.svgIcon" alt="" />
		<span *ngIf="option?.iconText" class="icon-text">{{ option?.iconText }}</span>
	</div>
</div>
<div class="mo-label" *ngIf="showMoLabels" [innerHTML]="moItem?.htmlLabel || '&nbsp;'"></div>
